<template>
  <div class="br-input-text">
    <v-text-field
      :label="label"
      :required="required"
      :disabled="disabled"
      v-model="internalValue"
      :rules="rules"
      :readonly="readonly"
      outlined
      dense
      hide-details="auto"
      class="br-form-field"
      color="primary"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: ["label", "value", "required", "disabled", "rules", "readonly"],
  data() {
    return {
      internalValue: "",
    };
  },
  watch: {
    internalValue(newValue) {
      this.$emit("input", newValue);
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.internalValue = newValue;
      },
    },
  },
});
</script>
